// Same helper as Scanner/src/getDate.ts, on the dashboard's `moment` instead of dayjs.
// The warehouse is in Morocco: dates are shown in Africa/Casablanca whatever the browser's zone.
import moment from "moment";

const tz = "Africa/Casablanca";
const inCasablanca = (date: Date) => {
    const shifted = new Date(date.toLocaleString("en-US", { timeZone: tz }));
    return moment(shifted);
};
const getDate = (date: Date, format = "DD MMMM YYYY hh:mm:ss A", daysAgo = 0) => {
    return inCasablanca(date).subtract(daysAgo, "day").format(format);
};
export function getRandomInt(min = 1, max = 100000) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
export default getDate;
